var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRailWithoutBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "icon-icon_rail-withoutBox",
    viewBox: "-909 491 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_rail-withoutBox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-814.6,540.3l-16.8-16.8c-0.4-0.4-1.1-0.7-1.7-0.7h-36.8l17.8-9c1.4-0.7,1.4-1.9,0-2.6l-19.9-10.4h-10.1l0,0.1l22.3,11.6l-20.3,10.4h-26.4v37.5l78.1,0c0,0,0.1,0,0.1,0l5.5,0c3.2,0,6.1-1.3,8.3-3.4c2.1-2.1,3.4-5.1,3.4-8.3C-811.2,545.4-812.5,542.4-814.6,540.3 M-846.5,536v-8.3h12.7l8.3,8.3H-846.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -906.5,
    y: 566,
    width: 81.3,
    height: 4.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRailWithoutBox);
export default __webpack_public_path__ + "static/media/rail-withoutBox.49edb2a89c4044000d308823679d07b6.svg";
export { ForwardRef as ReactComponent };